/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Chain_To_Previous_EventInputs */

const en_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap the Event incode to the previous Event's outcode`)
};

const fr_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accrocher l'incode de l'evenement a l'outcode de l'evenement precedent`)
};

const de_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordnen Sie den Ereignis-Incode dem Outcode des vorherigen Ereignisses zu.`)
};

const it_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega l'incode dell'evento all'outcode dell'evento precedente`)
};

const ru_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сопоставьте код входящего сигнала события с кодом исходящего сигнала предыдущего события.`)
};

const es_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar el código de entrada del evento al código de salida del evento anterior`)
};

const zh_cn2_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件的输入代码与前一个事件的输出代码对齐。`)
};

const ja_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのインコードを前のイベントのアウトコードにスナップします`)
};

const hi_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट इनकोड को पिछले इवेंट के आउटकोड से स्नैप करें`)
};

const pt_pt2_shortcut_keys_desc_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar o código de entrada do evento com o código de saída do evento anterior.`)
};

/**
* | output |
* | --- |
* | "Snap the Event incode to the previous Event's outcode" |
*
* @param {Shortcut_Keys_Desc_Chain_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_chain_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Chain_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_chain_to_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_chain_to_previous_event(inputs)
	return en_shortcut_keys_desc_chain_to_previous_event(inputs)
});